
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, ViewChild, Renderer2, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { InnerMenuLiveProcessService } from '../../inner-menu-liveprocess.service';
import { CommonService } from '../../../shared/service/shared.service';
import { ProcessItem, LiveProcessRequest } from '../../../shared/models/process.model';
import { CancelProcessComponent } from '../../../popup/cancel-process/cancel-process.component';

declare const $: any;

/** String resource — boşsa Türkçe varsayılan; değerler mevcut DB anahtarlarıyla uyumlu */
const LIVEPROCESS_KEYS = {
    title1: 'liveProcess_Title1',
    title2: 'liveProcess_Title2',
    title3: 'liveProcess_Title3',
    firmReference: 'liveProcess_FirmReference',
    productNo: 'liveProcess_ProductNo',
    processType: 'liveProcess_ProcessType',
    processTypeValue1: 'liveProcess_ProcessTypeValue1',
    processTypeValue2: 'liveProcess_ProcessTypeValue2',
    totalAmount: 'liveProcess_TotalAmount',
    processStatus: 'liveProcess_ProcessStatus',
    detail: 'liveProcess_Detail',
    noRecords: 'liveProcess_NoRecords',
    backButton: 'liveProcess_BackButton',
    actionDetail: 'liveProcess_ActionDetail',
    cancelButton1: 'liveProcess_CancelButton1',
    cancelButton2: 'liveProcess_CancelButton2',
    statusText1: 'liveProcess_StatusText1',
    statusText2: 'liveProcess_StatusText2',
    statusText3: 'liveProcess_StatusText3',
    statusText4: 'liveProcess_StatusText4',
    statusText5: 'liveProcess_StatusText5',
    statusText6: 'liveProcess_StatusText6',
    statusText7: 'liveProcess_StatusText7',
    statusText9: 'liveProcess_StatusText9',
    amountCurrencySuffix: 'liveProcess_AmountCurrencySuffix',
};

@Component({
    selector: 'liveprocess',
    templateUrl: './liveprocess.component.html',
    styleUrls: ['./liveprocess.component.css']
})
export class LiveProcessComponent extends SiriusBaseComponent<any> {
    @ViewChildren('elementTitles') elementTitles: QueryList<ElementRef>;
    @ViewChild('cancelPopup') cancelPopup: CancelProcessComponent;
    pageIndex: number;
    titleText: string = "";
    searchResultData: ProcessItem[] = [];
    noResult: boolean = false;
    selectedProcess: ProcessItem;
    cancelButtonText: string = "";
    cancelDisabled: boolean = false;
    /* String Resource — Türkçe varsayılan, loadLiveProcessResourceStrings ile DB’den güncellenir */
    liveProcess_Title1 = 'Canlı İşlemlerim';
    liveProcess_Title2 = 'İşlem Detayı';
    liveProcess_Title3 = 'İşlem Aksiyonları';
    liveProcess_FirmReference = 'Referans No:';
    liveProcess_ProductNo = 'Plaka No:';
    liveProcess_ProcessType = 'İşlem Türü:';
    liveProcess_ProcessTypeValue1 = 'SATIŞ';
    liveProcess_ProcessTypeValue2 = 'ALIŞ';
    liveProcess_TotalAmount = 'Tutar:';
    liveProcess_ProcessStatus = 'İşlem Durumu:';
    liveProcess_Detail = 'Detay';
    liveProcess_NoRecords = 'Gösterilecek işlem bulunamadı.';
    liveProcess_BackButton = 'Geri';
    liveProcess_ActionDetail = 'Devam';
    liveProcess_CancelButton1 = 'İptal Et';
    liveProcess_CancelButton2 = 'İptal Edildi';
    liveProcess_StatusText1 = 'Beklemede';
    liveProcess_StatusText2 = 'Devam ediyor';
    liveProcess_StatusText3 = 'Onay bekliyor';
    liveProcess_StatusText4 = 'Tamamlandı';
    liveProcess_StatusText5 = 'İptal';
    liveProcess_StatusText6 = 'Reddedildi';
    liveProcess_StatusText7 = 'Süresi doldu';
    liveProcess_StatusText9 = 'Diğer';
    /** Tutar sonrası para birimi (örn. " TL") */
    liveProcess_AmountCurrencySuffix = ' TL';
    constructor(private innerMenuLiveProcessService: InnerMenuLiveProcessService, private commonService: CommonService, private renderer: Renderer2) {
        super();
    }
    OnInit() {
        this.loadLiveProcessResourceStrings();
        this.pageIndex = 0;
        this.titleText = this.liveProcess_Title1;     
        this.commonService.selectedProcessDetail = null;
        this.commonService.selectedProcessAction = null;   
        this.searchProcess();       
    }
    private loadLiveProcessResourceStrings(): void {
        const r = (key: string, fallback: string) => this.commonService.getStringResource(key, fallback);

        this.liveProcess_Title1 = r(LIVEPROCESS_KEYS.title1, this.liveProcess_Title1);
        this.liveProcess_Title2 = r(LIVEPROCESS_KEYS.title2, this.liveProcess_Title2);
        this.liveProcess_Title3 = r(LIVEPROCESS_KEYS.title3, this.liveProcess_Title3);
        this.liveProcess_FirmReference = r(LIVEPROCESS_KEYS.firmReference, this.liveProcess_FirmReference);
        this.liveProcess_ProductNo = r(LIVEPROCESS_KEYS.productNo, this.liveProcess_ProductNo);
        this.liveProcess_ProcessType = r(LIVEPROCESS_KEYS.processType, this.liveProcess_ProcessType);
        this.liveProcess_ProcessTypeValue1 = r(LIVEPROCESS_KEYS.processTypeValue1, this.liveProcess_ProcessTypeValue1);
        this.liveProcess_ProcessTypeValue2 = r(LIVEPROCESS_KEYS.processTypeValue2, this.liveProcess_ProcessTypeValue2);
        this.liveProcess_TotalAmount = r(LIVEPROCESS_KEYS.totalAmount, this.liveProcess_TotalAmount);
        this.liveProcess_ProcessStatus = r(LIVEPROCESS_KEYS.processStatus, this.liveProcess_ProcessStatus);
        this.liveProcess_Detail = r(LIVEPROCESS_KEYS.detail, this.liveProcess_Detail);
        this.liveProcess_NoRecords = r(LIVEPROCESS_KEYS.noRecords, this.liveProcess_NoRecords);
        this.liveProcess_BackButton = r(LIVEPROCESS_KEYS.backButton, this.liveProcess_BackButton);
        this.liveProcess_ActionDetail = r(LIVEPROCESS_KEYS.actionDetail, this.liveProcess_ActionDetail);
        this.liveProcess_CancelButton1 = r(LIVEPROCESS_KEYS.cancelButton1, this.liveProcess_CancelButton1);
        this.liveProcess_CancelButton2 = r(LIVEPROCESS_KEYS.cancelButton2, this.liveProcess_CancelButton2);
        this.liveProcess_StatusText1 = r(LIVEPROCESS_KEYS.statusText1, this.liveProcess_StatusText1);
        this.liveProcess_StatusText2 = r(LIVEPROCESS_KEYS.statusText2, this.liveProcess_StatusText2);
        this.liveProcess_StatusText3 = r(LIVEPROCESS_KEYS.statusText3, this.liveProcess_StatusText3);
        this.liveProcess_StatusText4 = r(LIVEPROCESS_KEYS.statusText4, this.liveProcess_StatusText4);
        this.liveProcess_StatusText5 = r(LIVEPROCESS_KEYS.statusText5, this.liveProcess_StatusText5);
        this.liveProcess_StatusText6 = r(LIVEPROCESS_KEYS.statusText6, this.liveProcess_StatusText6);
        this.liveProcess_StatusText7 = r(LIVEPROCESS_KEYS.statusText7, this.liveProcess_StatusText7);
        this.liveProcess_StatusText9 = r(LIVEPROCESS_KEYS.statusText9, this.liveProcess_StatusText9);
        this.liveProcess_AmountCurrencySuffix = this.commonService.getStringResource(
            LIVEPROCESS_KEYS.amountCurrencySuffix,
            this.liveProcess_AmountCurrencySuffix);
    }
    getTypeText(type) {
        return type == "S" ? this.liveProcess_ProcessTypeValue1 : this.liveProcess_ProcessTypeValue2;
    }
    getStatusText(status) {
        let text = "";
        switch (status) {
            case "1":
                text = this.liveProcess_StatusText1;
                break;
            case "2":
                text = this.liveProcess_StatusText2;
                break;
            case "3":
                text = this.liveProcess_StatusText3;
                break;
            case "4":
                text = this.liveProcess_StatusText4;
                break;
            case "5":
                text = this.liveProcess_StatusText5;
                break;
            case "6":
                text = this.liveProcess_StatusText6;
                break;
            case "7":
                text = this.liveProcess_StatusText7;
                break;
            case "9":
                text = this.liveProcess_StatusText9;
                break;
        }
        return text;
    }
    searchProcess() {
        var liveProcessRequest: LiveProcessRequest = {
            StartDate: null,
            EndDate: null,
      }
      var promise = this.innerMenuLiveProcessService.getUserLiveProcess(this.dataService, liveProcessRequest).toPromise();
        promise.then((result) => {
            if (result != null && Array.isArray(result) && result.length > 0) {
                this.searchResultData = result as Array<ProcessItem>;
            }
            else {
                this.noResult = true;
                this.searchResultData = null;
            }
        });
    }
    goProcessDetail(index: number) {
        this.cancelDisabled = false;
        this.selectedProcess = this.searchResultData[index];
        this.pageIndex = this.pageIndex + 1;
    }
    elementTitleClicked(i: number) {
        var elementList = this.elementTitles.toArray();
        for (let j = 0; j < elementList.length; j++) {
            if (j == i) {
              if (elementList[j].nativeElement.children[0].classList.contains("open")) {
                this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
              }
              else {
                this.renderer.addClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.addClass(elementList[j].nativeElement.children[1], 'show');
              }
            }
            else {
                this.renderer.removeClass(elementList[j].nativeElement.children[0], 'open');
                this.renderer.removeClass(elementList[j].nativeElement.children[1], 'show');
            }
        }
        $(document).ready(() => {
            $(".list-group").animate({ scrollTop: $('#elementTitleOfSearchResult' + i).height() * i }, 600);
        });
    }
    backButtonClicked() {
        this.pageIndex = this.pageIndex - 1;
        if (this.pageIndex == 0) {
            this.titleText = this.liveProcess_Title1;
        }
        else {
            this.titleText = this.liveProcess_Title2;
        }
    }
    nextButtonClicked() {
        this.pageIndex = this.pageIndex + 1;
        if (this.pageIndex == 1) {
            this.titleText = this.liveProcess_Title2;
        }
        else {
            this.titleText = this.liveProcess_Title3;
        }  
    }    
    cancelProcess() {
        this.cancelPopup.showPopup();
    }
    onProcessCancel() {
        this.cancelDisabled = true;
        this.searchResultData = this.searchResultData.filter(x => x.FirmReference != this.selectedProcess.FirmReference);
        if (this.searchResultData.length == 0)
            this.noResult = true;
    }
}
